export default defineNuxtPlugin(() => {
  // TODO: remove. Filters in vue is unsupported in v3 and also cannot file usage of this filter
  // nuxtApp.vueApp.filter('date', (value, format) => moment(value).format(format));
});
